import React  from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

// components
import { LangController } from "../../../components/tabs/langController";

// labels
import { LB_TITLE } from "../../../components/i18n/i18n";


const CampaignLangs = props => {

    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            title : '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) =>  <Row>
        <Col md="12">
            <FormGroup>
                <Label>{LB_TITLE}</Label>
                <Input
                    type="text"
                    name="title"
                    placeholder={LB_TITLE}
                    value={ child.title || '' }
                    onChange={e => onInputChange(e, child.lang)}
                    disabled={ disableInputs }
                />
            </FormGroup>
        </Col>
    </Row>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
    />
}

export default CampaignLangs